/**
 * conso-menu-tracking.js
 * Rastreia cliques nos itens do menu (desktop + mobile) para o GA4 via GTM.
 *
 * Aditivo: não altera markup nem comportamento do header. Usa delegação de
 * evento no document (fase de captura) porque o header do Horizon re-renderiza
 * via Section Rendering API e o drawer monta submenus sob demanda — listeners
 * ligados direto nos links seriam perdidos no primeiro morph.
 *
 * Evento empurrado: 'menu_click'
 *   menu_location   desktop | mobile_drawer | mobile_nav_bar
 *   menu_level      top | submenu
 *   menu_item_text  rótulo do link (máx 100 chars, limite do GA4)
 *   menu_item_url   path do destino (sem domínio/query)
 *   menu_parent     rótulo do item pai; '(none)' no nível topo
 */
(function () {
  'use strict';

  var MAX_LEN = 100; // limite de tamanho de valor de parâmetro do GA4

  function clean(value) {
    if (!value) return '';
    return String(value).replace(/\s+/g, ' ').trim().slice(0, MAX_LEN);
  }

  function textOf(el, preferredSelector) {
    if (!el) return '';
    var node = preferredSelector ? el.querySelector(preferredSelector) : null;
    return clean((node || el).textContent);
  }

  function pathOf(anchor) {
    var href = anchor.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return clean(href);
    try {
      // Normaliza pra path puro: /colecoes/camisas em vez da URL absoluta.
      return clean(new URL(href, window.location.origin).pathname);
    } catch (e) {
      return clean(href);
    }
  }

  /**
   * Descobre onde o link clicado vive. A ordem importa: a barra de navegação
   * mobile e o drawer também casam com seletores genéricos de menu-list, então
   * os containers mais específicos são testados primeiro.
   */
  function describe(anchor) {
    // --- Mobile: drawer (hambúrguer) ---
    if (anchor.closest('.header-drawer, .menu-drawer__navigation')) {
      var isTopLevel = anchor.classList.contains('menu-drawer__menu-item--mainlist');
      var parent = '(none)';

      if (!isTopLevel) {
        // Submenu do drawer: o rótulo do pai fica no item mainlist ou no botão
        // de voltar do bloco que embrulha esse submenu. O drawer tem três
        // variantes de markup (lista plana, accordion e painel deslizante),
        // cada uma com um wrapper diferente — todas cobertas aqui.
        var wrapper = anchor.closest(
          '.menu-drawer__list-item--flat, .menu-drawer__list-item--deep, .menu-drawer__menu-container, .menu-drawer__submenu'
        );
        if (wrapper) {
          parent =
            textOf(wrapper.querySelector('.menu-drawer__menu-item--mainlist'), '.menu-drawer__menu-item-text') ||
            textOf(wrapper.querySelector('.menu-drawer__back-button'), '.menu-drawer__menu-item-text') ||
            '(none)';
        }
      }

      return {
        menu_location: 'mobile_drawer',
        menu_level: isTopLevel ? 'top' : 'submenu',
        menu_item_text: textOf(anchor, '.menu-drawer__menu-item-text'),
        menu_parent: parent || '(none)'
      };
    }

    // --- Mobile: barra de navegação horizontal (pílulas abaixo do header) ---
    if (anchor.closest('.menu-list--mobile')) {
      return {
        menu_location: 'mobile_nav_bar',
        menu_level: 'top',
        menu_item_text: textOf(anchor),
        menu_parent: '(none)'
      };
    }

    // --- Desktop: mega menu (submenu aberto no hover) ---
    if (anchor.classList.contains('mega-menu__link')) {
      var item = anchor.closest('.menu-list__list-item');
      return {
        menu_location: 'desktop',
        menu_level: 'submenu',
        menu_item_text: textOf(anchor),
        menu_parent: textOf(item && item.querySelector('.menu-list__link'), '.menu-list__link-title') || '(none)'
      };
    }

    // --- Desktop: item de topo ---
    if (anchor.classList.contains('menu-list__link')) {
      return {
        menu_location: 'desktop',
        menu_level: 'top',
        menu_item_text: textOf(anchor, '.menu-list__link-title'),
        menu_parent: '(none)'
      };
    }

    return null; // link fora do menu — ignora
  }

  function onClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    // Só âncoras com destino: expressa intenção de navegação. Botões/summary
    // que apenas abrem submenu não contam como clique de menu.
    var anchor = target.closest('a[href]');
    if (!anchor) return;

    var payload = describe(anchor);
    if (!payload || !payload.menu_item_text) return;

    payload.menu_item_url = pathOf(anchor);
    payload.event = 'menu_click';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  // Captura: dispara antes de qualquer handler do tema que possa chamar
  // stopPropagation ao fechar o drawer.
  document.addEventListener('click', onClick, true);
})();
